var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInActiveUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.685,
    height: 18.001,
    viewBox: "0 0 17.685 18.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_148",
    "data-name": "Subtraction 148",
    d: "M6205.021,12266a.9.9,0,0,1-.854-.613l-.548-1.647a.9.9,0,0,0-.851-.612.874.874,0,0,0-.184.019l-1.693.342a.9.9,0,0,1-.963-.432l-1.8-3.112a.892.892,0,0,1,.089-1.053l1.142-1.3a.9.9,0,0,0,0-1.188l-1.142-1.3a.892.892,0,0,1-.089-1.053l1.8-3.115a.916.916,0,0,1,.779-.438.926.926,0,0,1,.123.008l1.736.342a.861.861,0,0,0,.183.019.9.9,0,0,0,.852-.613l.5-1.646a.9.9,0,0,1,.851-.613h3.646a.9.9,0,0,1,.856.612l.548,1.646a.907.907,0,0,0,.855.613.861.861,0,0,0,.183-.019l1.69-.342a.919.919,0,0,1,.185-.02.9.9,0,0,1,.779.45l1.8,3.115a.9.9,0,0,1-.108,1.053l-1.151,1.3a.9.9,0,0,0,0,1.188l1.216,1.3a.892.892,0,0,1,.107,1.053l-1.8,3.112a.9.9,0,0,1-.777.451.912.912,0,0,1-.183-.02l-1.693-.342a.874.874,0,0,0-.184-.019.9.9,0,0,0-.851.612l-.548,1.647a.907.907,0,0,1-.856.612h-3.646Zm1.818-12.644a2.056,2.056,0,0,0-2.053,2.056,2.582,2.582,0,0,0,.483,1.459,3.9,3.9,0,0,0-1.825,1.678.6.6,0,0,0,.1.724,4.579,4.579,0,0,0,3.3,1.373,4.674,4.674,0,0,0,3.3-1.37.618.618,0,0,0,.1-.727,3.858,3.858,0,0,0-1.834-1.681,2.593,2.593,0,0,0,.48-1.456A2.055,2.055,0,0,0,6206.839,12253.356Z",
    transform: "translate(-6197.999 -12247.999)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveUserManagement);
export default __webpack_public_path__ + "static/media/InActiveUserManagement.ff1d5f0b12863953908617e1bf3eb5e5.svg";
export { ForwardRef as ReactComponent };